<template>
    <div v-loading="loading" class="mainbg">
        <div class="home">
            <breadcrumb/>
            <div style="padding: 10px 30px 40px 0px;" class="inner">
                <el-row>
                    <el-col :span="6">
                        <div>
                            <sideNavigation/>
                        </div>
                    </el-col>
                    <el-col :span="18">
                        <p id="A1"/>
                        <img src="../../assets/img/lineBlueText.png" class="information-img">
                        <!--<p class="information-text-title">  </p>-->
                        <div class="titleContent">
                            <pre>我部主动公开的政府信息能够通过工业和信息化部网站（www.miit.gov.cn）“政府信息公开专栏”查询，也可以通过“主动公开政府信息检索”进行查询。</pre>
                            <pre>本系统只受理公民、法人和其他组织向工业和信息化部申请获取除主动公开以外的政府信息公开申请，不受理问题咨询、业务办理、信访举报等事项，如您需咨询有关业务事项可拨打工业和信息化部公共服务电话12381。也可以点击进入工业和信息化部政府网站有关栏目进行咨询。</pre>
                            <pre>请申请人按照《工业和信息化部政府信息公开指南》要求填写申请，如申请人未按照要求提交申请，可能会导致申请被退回或无法及时得到处理。</pre>
                        </div>
                        <div class="middle">
                            <el-checkbox v-model="checked" style="color:#8492A6;">我已阅读上述须知</el-checkbox>
                        </div>
                        <div class="footer">
                            <el-button v-if="showButton" type="primary" @click="route_goFun2('表格填写')"
                                       style="font-size: 21px;margin-right: 20px">申请公开</el-button>
                            <el-button v-else type="primary" disabled style="font-size: 21px;margin-right: 20px">申请公开</el-button>
                            <span v-show="!showButton" style="display: inline-block">{{count}}s</span>
                        </div>
                        <!--<el-button type="info" style="margin-left: 50px;font-size: 21px">返回首页</el-button>-->
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
    import sideNavigation from '@/components/sideNavigation'
    import breadcrumb from '@/components/breadcrumb'
    import {GetQueryString} from '@/utils/utils'

    export default {
        components: {
            sideNavigation,
            breadcrumb
        },
        data() {
            return {
                checked: false,
                loading: false,
                count:'',
                showButton:true,
                timer: null,
            }
        },
        // beforeCreate() {
        //     //http://localhost:8180/api/application/getUser
        //     var cssSsoTicket = GetQueryString("cssSsoTicket");
        //     console.log(cssSsoTicket)
        //     if (cssSsoTicket) {
        //         this.$axios({
        //             url: '/login/getSUser',
        //             method: 'get',
        //             params: {
        //                 cssSsoTicket: cssSsoTicket
        //             }
        //         }).then(({data}) => {
        //                 debugger
        //             if (data.code == '401') {
        //                 const ssoUrl = data.data+'?toUrl=http://10.13.16.103:8280/'
        //                 // const ssoUrl = data.data+'?toUrl=http://localhost:8280/'
        //
        //                 window.open(ssoUrl, '_self');
        //             }
        //
        //         })
        //             .catch((error) => {
        //                 localStorage.setItem('IsLogin', '登录异常');
        //             });
        //     } else {
        //         this.$axios({
        //             url: '/login/getSUser',
        //             method: 'get',
        //         }).then(({data}) => {
        //             console.log(data)
        //             // debugger
        //             if (data.code == '401') {
        //                 const ssoUrl = data.data+'?toUrl=http://10.13.16.103:8280/'
        //                 // const ssoUrl = data.data+'?toUrl=http://localhost:8280/'
        //                 window.open(ssoUrl, '_self');
        //             }
        //
        //         })
        //
        //     }
        // },
        mounted() {
            if(sessionStorage.getItem('LoginTimeSixty')!='2'){
                this.sixtyTime()
            }
        },
        methods: {
            sixtyTime(){
                const TIME_COUNT = 60;
                if (!this.timer) {
                    this.count = TIME_COUNT;
                    this.showButton = false;
                    this.timer = setInterval(() => {
                        if (this.count > 0 && this.count <= TIME_COUNT) {
                            this.count--;
                        } else {
                            this.showButton = true;
                            clearInterval(this.timer);
                            this.timer = null;
                        }
                    }, 1000)
                }
            },
            route_goFun(name) {
                this.$router.push({
                    path: '/',
                    query: {
                        name: name,
                        id: 1
                    }
                })
            },
            route_goFun2(name) {
                var _this = this
                sessionStorage.setItem('sfsmrz', '0')
                var readNotice = this.checked
                if (readNotice) { // 是否勾选
                    _this.loading = true
                    this.$axios({
                        url: '/application/isStopService',
                        method: 'get'
                    }).then(({data}) => {
                        _this.loading = false
                        if (data.code == 200) {
                            if (data.isStopService) { // 是否处于维护中
                                this.$router.push({
                                    path: '/zwgk-no-access'
                                })
                            } else {
                                var cssSsoTicket = GetQueryString('cssSsoTicket')
                                // console.log(cssSsoTicket)
                                if (cssSsoTicket) {
                                    this.$axios({
                                        url: '/login/getSUser',
                                        method: 'get',
                                        params: {
                                            cssSsoTicket: cssSsoTicket
                                        }
                                    }).then(({data}) => {
                                        // console.log(data)
                                        // sessionStorage.setItem('cssSsoTicket',cssSsoTicket')
                                        sessionStorage.setItem('loginName', data.data.loginName)
                                        sessionStorage.setItem('personUuid', data.data.userId)
                                        sessionStorage.setItem('certno', data.data.certNo)
                                        sessionStorage.setItem('LoginTimeSixty', '2')
                                        this.goData(data)
                                    }).catch(() => {
                                        localStorage.setItem('IsLogin', '登录异常')
                                        this.$message({
                                            message: '登录异常',
                                            type: 'error'
                                        })
                                    })
                                } else {
                                    this.$axios({
                                        url: '/login/getSUser',
                                        method: 'get'
                                    }).then(({data}) => {
                                        // console.log(data)
                                        sessionStorage.setItem('loginName', data.data.loginName)
                                        // console.log(data.data.loginName)
                                        sessionStorage.setItem('LoginTimeSixty', '2')
                                        this.goData(data)
                                    }).catch(() => {
                                        localStorage.setItem('IsLogin', '登录异常')
                                        this.$message({
                                            message: '登录异常',
                                            type: 'error'
                                        })
                                    })
                                }
                            }
                        } else {
                            this.$message({
                                message: data.msg,
                                type: 'error'
                            })
                        }
                    }).catch((error) => {
                        _this.loading = false
                        this.$message({
                            message: error,
                            type: 'error'
                        })
                    })
                } else {
                    this.$message({
                        showClose: true,
                        message: '请阅读《系统使用说明》,并勾选我已阅读上述须知。',
                        type: 'success'
                    })
                }
            },
            goData(data) {
                if (data.code == '401') {
                    const ssoUrl = data.data + '?toUrl=' + window.SITE_CONFIG['baseUrl1']
                    window.open(ssoUrl, '_self')
                } else if (data.data.userType == null || data.data.userType == '') {
                    this.$confirm('您还没有实名认证!', '提示', {
                        confirmButtonText: '去实名',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        window.open(window.SITE_CONFIG['registerUrl'] + data.data.userId, '_self')
                    }).catch(() => {

                    })
                } else {
                    sessionStorage.setItem('sfsmrz', '1')
                    this.$router.push({
                        path: '/apply-table-write',
                        query: {
                            name: name,
                            id: 2
                        }
                    })
                }
            },

            to() {
                this.$router.push({
                    path: '/apply-table-write',
                    query: {
                        name: name,
                        id: 2
                    }
                })
            }
        }
    }
</script>

<style>
    .text {

    }

    pre {
        white-space: pre-wrap;
        white-space: -moz-pre-wrap;
        white-space: -o-pre-wrap;
        *word-wrap: break-word;
        *white-space: normal;
        text-align: left;
        font-size: 16px;
        color: #7F848D;
        text-indent: 2em;
        letter-spacing: 2px;
        line-height: 20px;
    }

</style>

